<div class="full-height layout-column">

  <!--Table Skeleton, shown only until the orders have loaded for the first time-->
  <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton fade-element-in-only">

    <div class="layout-row layout-align-start-center tr-header">
      <div class="th skeleton-col-checkbox"></div>
      <div class="th skeleton-col-lg"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-lg"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
    </div>

    <div class="layout-row layout-align-start-center tr" *ngFor="let row of skeletonRows">
      <div class="td skeleton-col-checkbox">
        <div class="bringoz-skeleton skeleton-checkbox"></div>
      </div>
      <div class="td skeleton-col-lg layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 80%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55%"></div>
      </div>
      <div class="td skeleton-col-sm layout-row">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 40%"></div>
      </div>
      <div class="td skeleton-col-sm">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div>
      </div>
      <div class="td skeleton-col-lg">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 85%"></div>
      </div>
      <div class="td skeleton-col-sm">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 75%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
      </div>
      <div class="td skeleton-col-md">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div>
      </div>
    </div>

  </div>

  <!--Table-->
  <div class="flex layout-column bringoz-table bringoz-table-sticky scrollable"
       [hidden]="!isInitialized || !orders.length">

    <!--Table Headers-->
    <div id="header" class="tr layout-row layout-align-start-center">

      <div class="flex-10 layout-row layout-align-start-start th sticky large text-center">
        <app-bringoz-checkbox [isDisabled]="!orders.length"
                              [isChecked]="(!excludeMode && !!selectedIds.length) || (excludeMode && !selectedIds.length)"
                              [isIndeterminate]="(!excludeMode && !!selectedIds.length && ordersCount > selectedIds.length) || excludeMode && !!selectedIds.length"
                              (clickEvent)="onToggleSelectAll()">
        </app-bringoz-checkbox>

        <span translate>Order</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortExternalIdType')">
          <bringoz-icon [iconName]="sortType?.name === 'sortExternalIdType' ?
                                asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>

      <!--Account-->
      <div class="th large flex" *ngIf="columns.account?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.account' | translate}}</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortAccountReferenceNameType')">
          <bringoz-icon [iconName]="sortType?.name === 'sortAccountReferenceNameType' ?
                                asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Account External ID-->
      <div class="th large flex" *ngIf="columns.accountExternalId?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.accountExternalId' | translate}}</span>
      </div>

      <!--Branches-->
      <div class="th large flex" *ngIf="columns.branches?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.branches' | translate}}</span>
      </div>


      <!--Contact/Phone/Locations/Program type-->
      <div class="th-multiple flex-40 layout-row">
        <div class="th small flex" *ngIf="columns.contact?.enabled">{{'OMS_TABLE_COLUMNS.contact' | translate}}</div>
        <div class="th small flex" *ngIf="columns.phone?.enabled">{{'OMS_TABLE_COLUMNS.phone' | translate}}</div>
        <div class="th large flex-40" *ngIf="columns.location?.enabled">
          {{'OMS_TABLE_COLUMNS.location' | translate}}
        </div>
      </div>

      <!--Relations-->
      <div class="th small flex" *ngIf="columns.relations?.enabled">
        {{'OMS_TABLE_COLUMNS.relations' | translate}}
      </div>

      <!--Program Type-->
      <div class="th small flex" *ngIf="columns.programType?.enabled">
        {{'OMS_TABLE_COLUMNS.programType' | translate}}
      </div>

      <!--SLA-->
      <div class="th small flex-5" *ngIf="columns.sla?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.sla' | translate}}</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortSlaType')">
          <bringoz-icon [iconName]="sortType?.name === 'sortSlaType' ?
                                asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Time To Deliver-->
      <div class="th small flex-5" flex="5" *ngIf="columns.timeToDeliver?.enabled">
        {{'OMS_TABLE_COLUMNS.timeToDeliver' | translate}}
      </div>

      <!--Fulfillment Status-->
      <div class="th small flex-10" *ngIf="columns.fulfillmentStatus?.enabled">
        <span translate>Fulfillment Status</span>
      </div>

      <!--Reference ids-->
      <div class="th small flex-5" *ngIf="columns.referenceIds?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.referenceIds' | translate}}</span>
      </div>

      <!--Created Time-->
      <div class="th small flex-5" *ngIf="columns.createdAt?.enabled">
        <span>{{'OMS_TABLE_COLUMNS.createdAt' | translate}}</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortCreatedAtType')">
          <bringoz-icon [iconName]="sortType?.name === 'sortCreatedAtType' ?
                                asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>


      <!--PRO Number-->
      <div class="th small flex" *ngIf="columns.proNumber?.enabled">
        {{'OMS_TABLE_COLUMNS.proNumber' | translate}}
      </div>

      <!--SCHEDULING SMS-->
      <div class="th medium flex" *ngIf="columns.schedulingSms?.enabled">
        <span translate>OMS_TABLE_COLUMNS.schedulingSms</span>
        <bringoz-button type="tertiary"
                        class="sort-button"
                        (click)="onSortChange('sortSchedulingSmsType')">
          <bringoz-icon [iconName]="sortType?.name === 'sortSchedulingSmsType' ?
                                asceDescIconsMap[sortType?.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Billing order-->
      <div class="th small flex" *ngIf="columns.billingOrder?.enabled">
        <span translate>OMS_TABLE_COLUMNS.billingOrder</span>
      </div>

      <!--Items Types-->
      <div class="th small flex" *ngIf="columns.itemsIds?.enabled">
        <span translate>OMS_TABLE_COLUMNS.itemsIds</span>
      </div>

      <!--Items Types-->
      <div class="th small flex" *ngIf="columns.itemsTypes?.enabled">
        <span translate>OMS_TABLE_COLUMNS.itemsTypes</span>
      </div>

      <!--Items Barcodes -->
      <div class="th small flex" *ngIf="columns.itemsBarcodes?.enabled">
        <span translate>OMS_TABLE_COLUMNS.itemsBarcodes</span>
      </div>

      <!--Pallets -->
      <div class="th small flex" *ngIf="columns.pallets?.enabled">
        <span translate>OMS_TABLE_COLUMNS.pallets</span>
      </div>

      <!--Notes-->
      <div class="th large flex-10" *ngIf="columns.notes?.enabled">
        <span translate>OMS_TABLE_COLUMNS.notes</span>
      </div>

      <!--Dynamic Columns-->
      <div *ngFor="let column of enabledDynamicColumns"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        {{column.title}}
      </div>

      <!--Packages Dynamic Columns-->
      <div *ngFor="let column of enabledPackageDynamicColumns"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        {{column.title}}
      </div>

    </div>

    <!--Table Body-->
    <div class="flex layout-column rows-container full-height">

      <!--Repeater-->
      <div class="full-height flex layout-column">
        <cdk-virtual-scroll-viewport [itemSize]="75" class="flex viewport"
                                     (scroll)="getNextBatch()">

          <app-oms-orders-table-row *cdkVirtualFor="let order of orders"
                                    class="item"
                                    [order]="order"
                                    [canRecover]="canRecoverOrders"
                                    [columns]="columns"
                                    [enabledDynamicColumns]="enabledDynamicColumns"
                                    [enabledPackageDynamicColumns]="enabledPackageDynamicColumns"
                                    [isSelected]="(!excludeMode && selectedKeys[order.id]) || (excludeMode && !selectedKeys[order.id])"
                                    (onToggleSelect)="onToggleOrderSelect(order)"
                                    (onFilterByType)="onFilterByType.emit({type: $event.type, value: $event.value})"
                                    (onSendToDispatch)="onSendToDispatch.emit($event)"
                                    (onAddNote)="onAddNote.emit($event)"
                                    (onSetOrderOnHold)="onSetOrderOnHold.emit($event)"
                                    (onResumeOrder)="onResumeOrder.emit($event)"
                                    (onManuallyCompleteOrder)="onManuallyCompleteOrder.emit($event)"
                                    (onEdit)="onEdit.emit($event)"
                                    (onDuplicate)="onDuplicate.emit($event)"
                                    (onPrintBillOfLading)="onPrintBillOfLading.emit($event)"
                                    (onDownloadBillOfLading)="onDownloadBillOfLading.emit($event)"
                                    (onSendSchedulingSMSClicked)="onSendSchedulingSms.emit($event)"
                                    (onSendSchedulingWhatsappClicked)="onSendSchedulingWhatsapp.emit($event)"
                                    (onViewSchedulingLink)="onViewSchedulingLink.emit()"
                                    (onRecover)="onRecover.emit($event)"
                                    (onCancelOrder)="onCancelOrder.emit($event)">

          </app-oms-orders-table-row>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

  </div>

  <!--Empty State-->
  <div *ngIf="!isLoading && !!isInitialized && !orders.length"
       class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
    <app-empty-state src="assets/images/empty_state/empty_state_location_box.svg"
                     text="No Orders Found">

    </app-empty-state>
  </div>

</div>
